
import React, { useState, useEffect } from "react";

// reactstrap components
import {
  Container,
} from "reactstrap";
import useGlobal from "store";

import bgImage from "assets/img/stats4.jpg";
import { Redirect } from "react-router-dom";
import OnboardingInputCard from "./OnboardingInputCard";

const OnboardingBusiness = (props) => {

    const [redirectRoute, setRedirectRoute] = useState(false);

    const [onboardingState] = useGlobal(
        state => state.onboarding
    );

    useEffect(() => {
        console.log('onboarding state', onboardingState);
        if(onboardingState.business_complete) {
            setRedirectRoute('/onboarding/start');
        } else if(!onboardingState.basic_complete) {
            setRedirectRoute('/onboarding/start');
        }
    }, [onboardingState]);

    const onboardingSteps = onboardingState.steps.business.map((step,i) => <OnboardingInputCard key={i} section={"business"} step={step}></OnboardingInputCard>);

  return ( redirectRoute ?  <Redirect to={redirectRoute} /> 
    : <>
        <div className="content">
            <Container className="onboarding-input-page">
            {onboardingSteps}
          </Container>
        </div>
        <div
          className="full-page-background"
          style={{ backgroundImage: "url(" + bgImage + ")" }}
        />
      </>
    );
}

export default OnboardingBusiness;
